// extracted by mini-css-extract-plugin
export default {"scrollContainer":"OsI85mFXJyyFPwNd9uk9","disablePointer":"pYfU8tkN4tXMzIKx0Nwk","hideScrollbarContent":"jkMaB1ZhPnBGC01p92e7"};